import React from "react";
import Hero from "../../components/services/dm/Hero";
import Services from "../../components/services/dm/Services";
import ResultSection from "../../components/services/dm/Result";
import Aboutdm from "../../components/services/dm/Aboutdm";
import WhyChooseUs from "../../components/services/dm/WhyChooseus";
import Dmteam from "../../components/services/dm/Dmteam";
import Pricing from "../../components/services/dm/Pricing";
import DmDetailed from "../../components/services/dm/Dmdetailed";
import { Helmet } from "react-helmet-async";
function DM() {
  return (
    <div>
      <Helmet>
        <title>
          Digital Marketing Services in India | SEO, Google Ads & Lead
          Generation
        </title>

        <meta
          name="description"
          content="Professional digital marketing services including SEO, Google Ads, Meta Ads, social media marketing, lead generation, performance marketing and business growth solutions."
        />

        <meta
          name="keywords"
          content="Digital Marketing Services, SEO Services, Google Ads Management, Meta Ads, Social Media Marketing, Lead Generation, Performance Marketing, Digital Marketing Agency"
        />

        <link rel="canonical" href="https://webxsecure.in/digital-marketing" />

        <meta
          property="og:title"
          content="Digital Marketing Services | SEO, Google Ads & Lead Generation"
        />

        <meta
          property="og:description"
          content="Professional SEO, Google Ads, social media marketing and lead generation services designed to accelerate business growth."
        />

        <meta
          property="og:url"
          content="https://webxsecure.in/digital-marketing"
        />

        <meta property="og:image" content="https://webxsecure.in/logo.png" />

        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />

        {/* Service Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Digital Marketing Services",
            provider: {
              "@type": "Organization",
              name: "Web X Secure",
            },
            serviceType: "Digital Marketing",
            areaServed: "India",
            url: "https://webxsecure.in/digital-marketing",
          })}
        </script>

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Digital Marketing",
                item: "https://webxsecure.in/digital-marketing",
              },
            ],
          })}
        </script>
      </Helmet>
      <Hero />
      <Services />
      <ResultSection />
      <Aboutdm />
      <WhyChooseUs />
      <Dmteam />
      <Pricing />
      <DmDetailed />
    </div>
  );
}

export default DM;
